import { Container, Error as ErrorPage } from 'metrix-common3';
import { useIntl } from 'react-intl';
import { BrowserRouter, Navigate, Route, Routes as RouterRoutes } from 'react-router-dom';
import Policies from '../../containers/Policies';
import Profile from '../../containers/Profile';

const Routes = (props) => {
    const intl = useIntl();

    const pageNotFoundText = intl.formatMessage({ id: 'Routes.error.pageNotFound' });
    const homeText = intl.formatMessage({ id: 'Routes.error.home' });
    const accessDeniedText = intl.formatMessage({ id: 'Routes.error.accessDenied' });
    const unknownErrorText = intl.formatMessage({ id: 'Routes.error.unknownError' });

    const fourOhFour = {
        errorStatus: '404',
        errorMsg: pageNotFoundText,
        redirectionLocation: '/policies',
        redirectionText: homeText,
    };

    const accessDenied = {
        errorStatus: '403',
        errorMsg: accessDeniedText,
        redirectionLocation: '/policies',
        redirectionText: homeText,
    };

    return (
        <BrowserRouter>
            <Container {...props}>
                <RouterRoutes>
                    <Route path='/' element={<Navigate to='/policies' replace />} />
                    <Route path='/policies/*' element={<Policies {...props} />} />
                    <Route path='/bordereaux/*' element={<Policies {...props} />} />
                    <Route path='/profile' element={<Profile {...props} />} />
                    <Route path='/404' element={<ErrorPage value={fourOhFour} />} />
                    <Route path='/403' element={<ErrorPage value={accessDenied} />} />
                    <Route
                        path='/error'
                        element={
                            <ErrorPage
                                value={{
                                    errorMsg: unknownErrorText,
                                    errorStatus: '---',
                                    redirectionLocation: '/policies',
                                    redirectionText: homeText,
                                }}
                            />
                        }
                    />
                    <Route path='*' element={<ErrorPage value={fourOhFour} />} />
                </RouterRoutes>
            </Container>
        </BrowserRouter>
    );
};

export default Routes;
